export const accountInfo = (state) => state.accountReducer;
export const userInfo = (state) => state.user;
export const userData = (state) => state.user.userData;
